import React from 'react';

// Generic 404 Handler component - Could use a touch-up

function NotFound() {
    return (
        <div>
            <p>Whoops! Couldn't find that page!</p>
        </div>
    )
}

export default NotFound;